import { render } from "./ResetProject.vue?vue&type=template&id=54675f9b&scoped=true"
import script from "./ResetProject.vue?vue&type=script&lang=js"
export * from "./ResetProject.vue?vue&type=script&lang=js"

import "./ResetProject.vue?vue&type=style&index=0&id=54675f9b&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54675f9b"]])

export default __exports__